import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgFormElementsModule } from '@mycicero/ng-form-elements'
import { NgMarkdownComponent } from '@mycicero/ng-markdown'
import { ButtonModule } from 'primeng/button'
import { DropdownModule } from 'primeng/dropdown'
import { InputMaskModule } from 'primeng/inputmask'
import { InputSwitchModule } from 'primeng/inputswitch'
import { InputTextModule } from 'primeng/inputtext'
import { MessageModule } from 'primeng/message'
import { PasswordModule } from 'primeng/password'
import { DisablePasteDirective } from './disable-copy-paste/disable-paste.directive'
import { ExternalLinkDirective } from './external-links/external-link.directive'
import { FloatingLabelComponent } from './floating-label/floating-label.component'
import { InputContainerComponent } from './input-container/input-container.component'
import { MandatoryDirective } from './mandatory/mandatory.directive'
import { MobilePhoneInputComponent } from './mobile-phone-input/mobile-phone-input.component'
import { MobilePhoneSelectionFormComponent } from './mobile-phone-selection-form/mobile-phone-selection-form.component'
import { NewPasswordFormComponent } from './new-password-form/new-password-form.component'
import { ResetOnEmptyDirective } from './reset-on-empty/reset-on-empty.directive'

@NgModule({
  declarations: [
    InputContainerComponent,
    MobilePhoneInputComponent,
    FloatingLabelComponent,
    MandatoryDirective,
    DisablePasteDirective,
    NewPasswordFormComponent,
    ResetOnEmptyDirective,
    MobilePhoneSelectionFormComponent,
    ExternalLinkDirective,
  ],
  imports: [
    CommonModule,
    DropdownModule,
    InputTextModule,
    FormsModule,
    ButtonModule,
    InputMaskModule,
    MessageModule,
    ReactiveFormsModule,
    InputSwitchModule,
    PasswordModule,
    NgFormElementsModule,
    NgMarkdownComponent,
  ],
  exports: [
    InputContainerComponent,
    MobilePhoneInputComponent,
    FloatingLabelComponent,
    MandatoryDirective,
    DisablePasteDirective,
    NewPasswordFormComponent,
    ResetOnEmptyDirective,
    MobilePhoneSelectionFormComponent,
    ExternalLinkDirective,
  ],
})
export class FormElementsModule {}
